export const headingStatistics = [
  { title: "Food", value: "123" },
  { title: "Personal Care", value: "456" },
  { title: "Household", value: "789" },
];

export const sampleUnitsDistributed = [
  { month: "Jan", units: 120 },
  { month: "Feb", units: 150 },
  { month: "Mar", units: 170 },
  { month: "Apr", units: 140 },
  { month: "May", units: 180 },
  { month: "Jun", units: 200 }
];

export const sampleValueDistributed = [
  { month: "Jan", value: 500 },
  { month: "Feb", value: 600 },
  { month: "Mar", value: 700 },
  { month: "Apr", value: 650 },
  { month: "May", value: 800 },
  { month: "Jun", value: 900 }
];